import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../reducers';
import {AuthenticationService} from '../../../../authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalService} from '../../../../global.service';
import {HttpClient} from '@angular/common/http';
import {SeasonsService} from '../../../seasons/seasons.service';
import {MatDialog} from '@angular/material';
import {UsersService} from '../../../users/users.service';

@Component({
  selector: 'elastic-racing-stats',
  templateUrl: './racing-stats.component.html',
  styleUrls: ['./racing-stats.component.scss']
})
export class RacingStatsComponent implements OnInit {

  data = {};
  dataLoaded = false;

  constructor(private store: Store<fromRoot.State>,
              private cd: ChangeDetectorRef,
              private authenticationService : AuthenticationService, private route: ActivatedRoute,
              private router: Router,
              private globalService: GlobalService,
              private http: HttpClient,
              private seasonsService: SeasonsService,
              private dialog: MatDialog,
              private usersService: UsersService,
              private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    /*
    this.http.get(this.globalService.apiUrl + '/dashboard/racingStats').subscribe( (data: any) => {
      this.data = data;
      this.dataLoaded = true;
      console.log(this.data);
      this.cdr.detectChanges();
    });
    */
  }

}
